/**
 * AdaliaMeDatagridPrefilGroupsRepeatable Component specific for Adalia M&E.
 *
 * This component renders a repeatable region where users cannot add or remove rows.
 * It allows for normal fields to be included within the repeated rows.
 * When the form opens for the first time in a project context,
 * it automatically generates rows based on values returned from the datagrid.
 *
 */
import React from 'react';

import { fetchJson } from '../../../../helpers/fetch.js';

import {
  Resolver,
  RepeatableRegion,
  OptionalRegion,
  DropdownSelection,
  GridLayout,
  AdaliaDatagridRowUpdater,
  AdaliaMeDatagridColumnConfigurator
} from '../../form_components.jsx';

import { Mode } from '../../common.jsx';

import Setting from '../setting.jsx'
import Helpers from '../header.jsx';

import {FormContext} from '../../form_context.jsx';
import {resolveComponentProps} from '../../form_viewer.jsx';

import {
  datagrid_get_grouped_rows_by_preset_path
} from '~/routes';

export default class AdaliaMeDatagridPrefilGroupsRepeatable extends RepeatableRegion {
  static contextType = FormContext;

  static get TYPE() {
    return 'adalia_me_datagrid_prefil_groups_repeatable';
  }

  static icon() {
    return <i className='fa fa-calculator'></i>;
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_default_label'
    };
  }

  static dropComponent(dropArea, targetContent, droppedContent, components, isNested) {
    if ([AdaliaMeDatagridPrefilGroupsRepeatable.TYPE, RepeatableRegion.TYPE, OptionalRegion.TYPE, AdaliaDatagridRowUpdater.TYPE].includes(droppedContent.type))
      return false;

    if (droppedContent.datagridId && targetContent.datagridId != droppedContent.datagridId && (targetContent.component?.id || targetContent.id) == dropArea.getAttribute('data-component-id')) {
      // alert(I18n.t('component_belongs_to_another_data_grid', {scope: 'fe'}));
      // return false;
    }

    if (GridLayout.TYPE == droppedContent.type) {
      droppedContent.datagridId = targetContent.datagridId;
      droppedContent.rowGroupCols = targetContent.rowGroupCols;
      droppedContent.presetId = targetContent.presetId;
      droppedContent.readOnly = false;

    } else if (AdaliaMeDatagridColumnConfigurator.TYPE == droppedContent.type && targetContent.datagridId == droppedContent.datagridId) {
      droppedContent.rowGroupCols = targetContent.rowGroupCols;
      droppedContent.presetId = targetContent.presetId;
      droppedContent.readOnly = true;

      if (droppedContent.rowGroupCols.includes(droppedContent.colAccessor)) {
        droppedContent.type = AdaliaMeDatagridPrefilGroupsDropdown.TYPE;
        droppedContent.options = [];
      }
    }

    return super.dropComponent(dropArea, targetContent, droppedContent, components, isNested);
  }

  static resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope = '') {
    if (!content) { return [] }
    if (!this.ANSWER_DEPENDENT) { return [] }

    let names = [];
    names.push(repeatedFieldScope + '[row_duplication_count]');

    // Add the current component
    if (content.name) { names.push(repeatedFieldScope + '[' + content.name + ']') }

    // Call for each child in the row context
    let childNames = [] ;
    (content.rows || []).forEach((row, i) => {
        (row || []).forEach((cell) => {
            childNames.push(Resolver.componentClass(cell.component.type).resolveRelatedAnswerNamesOrIds(cell.component, content.name + '[row-' + i + ']'));
        });
    });
    return [...names, ...childNames.flat()];
  }

  componentDidMount() {
    super.componentDidMount();

    var projectId = this.context.projectId || jQuery('#report-container').data('project-id');

    if (projectId && this.props.mode == Mode.FILL && _.isEmpty(this.props.answers)) {
      this.setState({loading: true});

      var usedGroupCols = [];
      var components = [];
      var answers = {};
      var rows = [];

      var joinGrids = [];
      this.constructor.nestedComponents(this.props.content).forEach((c) => {
        if (c.colAccessor) components.push(c);
        if (c.type == AdaliaMeDatagridPrefilGroupsDropdown.TYPE) usedGroupCols.push(c.colAccessor); 

        if (c.datagridId && c.presetId) {
          joinGrids.push({
            datagridId: c.datagridId,
            presetId: c.presetId,
            selectedGrouping: c.groupKeys
          })
        }
      });

      
      let queryObject = {
        // Prefill the rows with following details 
        // - All rows from the datagrid with given preset and selected grouping
        // - Join rows from other datagrids with given preset and grouping
        prefillRows: {
          datagridId: this.props.content.datagridId,
          presetId: this.props.content.presetId,
          selectedGrouping: usedGroupCols
        }, 
        joinRows: joinGrids
      };

      // Front-end join from multiple grids. For GCF Demo. Proper implementation in later iterations
      fetchPrefilledRows(queryObject, projectId, this.context.programmeFormId,
        (res) => {
          if (res) {
            res.forEach((row, idx) => {
              components.forEach((c) => {
                let answer = row[c.colAccessor] == undefined ? '' : row[c.colAccessor];
                answers['row-' + idx] ||= {};

                if (_.isObject(answer)) {
                  answers['row-' + idx][c.name] = answer.id;
                  answers['row-' + idx][c.name+'_label'] = answer.label;
                } else {
                  answers['row-' + idx][c.name] = answer;
                }

                answers['row-' + idx]['row_duplication_count'] = row['row_duplication_count'] || 1;
              });
            });

            for (let i = 0; i < res.length; i++) {
              rows.push('row-' + i);
            }

            this.setState({rows: rows, loading: false});
            this.props.updateAnswerCallback(this.props.content.name, answers);
          }
        }
      );
        
      // Pre-implementation with just one col. Kept here until finalised
      // fetchOptionsForSelect(
      //   this.props.content.datagridId,
      //   this.props.content.presetId,
      //   usedGroupCols,
      //   projectId,
      //   this.props.handleDisbursement,
      //   (res) => {
      //     if (res) {
      //       res.forEach((row, idx) => {
      //         components.forEach((c) => {
      //           let answer = row[c.colAccessor] == undefined ? '' : row[c.colAccessor];
      //           answers['row-' + idx] ||= {};

      //           if (_.isObject(answer)) {
      //             answers['row-' + idx][c.name] = answer.id;
      //             answers['row-' + idx][c.name+'_label'] = answer.label;
      //           } else {
      //             answers['row-' + idx][c.name] = answer;
      //           }

      //           answers['row-' + idx]['row_duplication_count'] = row['row_duplication_count'] || 1;
      //         });
      //       });

      //       for (let i = 0; i < res.length; i++) {
      //         rows.push('row-' + i);
      //       }

      //       this.setState({rows: rows, loading: false});
      //       this.props.updateAnswerCallback(this.props.content.name, answers);
      //     }
      //   });
    }
  }

  renderView() {
    let rows = [];

    this.state.rows.forEach((rowId, i) => {
      let component = null;
      if (this.props.content.component) {
        component = Resolver.createElement(this.props.content.component.type, resolveComponentProps(this.props.content.component, this.props,
        {
            selectCallback: this.props.selectCallback,
            selectedId: this.props.selectedId,
            prefillAnswers: this.prefillAnswers[rowId],
            repeatedFieldScope: this.props.content.name + '[row-' + i + ']',
            repeatedFieldRowIndex: i,
          })
        )
      } else if (this.inEditMode) {
        component = <Helpers.DropArea componentId={this.props.content.id} />;
      }
      rows.push(
        <div key={rowId} className='component-row'>
          <div className='component'>
            {component}
            {this.props.answers?.[this.props.content.name]?.[rowId] != null &&
              <input type='hidden' name={`${this.props.fieldScope}[${this.props.content.name}[${rowId}][row_duplication_count]]`} defaultValue={this.props.answers[this.props.content.name][rowId]['row_duplication_count']} />
            }
          </div>
        </div>
      )
    });

    return (
      <div className={this.props.content.condensedMode ? 'condensed_mode': ''}>
        <label className={this.props.content.label_hidden ? 'hidden-label': ''}><span className='field-label'>{this.getText('label')}</span></label>
        {this.state.loading ? I18n.t('loading') : rows}
        <input type='hidden' name={this.fullFieldName() + '[row_count]'} defaultValue={rows.length} />
      </div>
    );
  }

  renderSettings() {
    return <div>
      {this.renderDataGridDetails()}
      <Setting.TextField name='label' label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings}/>
      <Setting.Checkbox name='condensedMode' label={I18n.t('field_condensed_mode', {scope: 'fe'})} description={I18n.t('field_condensed_mode_description', {scope: 'fe'})} value={this.props.content.condensedMode} onChange={this.updateSettings}/>
    </div>;
  }
}

export class AdaliaMeDatagridPrefilGroupsDropdown extends DropdownSelection {

  static get TYPE() {
    return 'adalia_me_datagrid_prefil_groups_dropdown';
  }

  static resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope = '') {
    let labels = [];
    if (content.name) {
      labels.push(repeatedFieldScope + "[" + content.name + "_label]");
    }

    return [...(super.resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope) || []), ...labels];
  }

  getOptions(_) {
    return [];
  }

  renderOptions() {
    let value = this.getAnswer();
    let label = this.getAnswerLabel();
    let options = <option value={value}>{label}</option>;

    return (
      <div style={{position: 'relative'}}>
        {<input type='hidden' name={this.fullFieldName(false, '_label')} value={label}/>}

        <select
          name={this.fullFieldName()}
          value={value}
          readOnly={true}
          disabled={this.props.mode != Mode.FILL && this.props.mode != Mode.EDIT}
          onMouseDown={this.selectClicked}
          className={`form-control locked ${this.getInputClassNames()}`}
          autoComplete={this.getAutoComplete()}
        >
          {options}
        </select>
        {this.renderPrefillIcon(true)}
      </div>
    );
  }

  getAnswerLabel() {
    let fieldNamePath = this.fullFieldName(false, '_label').split(/[\[\]]+/).filter((s) => (['', this.props.fieldScope].indexOf(s) == -1));
    return Helpers.getObjectValue(this.props.answers || {}, fieldNamePath) || '';
  }

  renderSettings() {
    return <div>
      {this.renderDataGridDetails()}
      <Setting.TextField name='label' label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name='label_hidden' className='label-hidden-check' label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
      <Setting.LongTextField name='description' label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.LongTextField name='help' label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
      <Setting.TextField
        name="reportKey"
        label={I18n.t('field_report_key', {scope: 'fe'})}
        value={this.props.content.reportKey}
        description={I18n.t('field_report_key_description', {scope: 'fe'})}
        {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
      />
    </div>
  }
}

// const fetchOptionsForSelect = (datagrid_id, preset_id, used_group_cols, project_id, handlingEnabled, cb) => {
//   fetchJson(datagrid_get_grouped_rows_by_preset_path({id: datagrid_id, datagrid_preset_id: preset_id, used_group_cols: used_group_cols, project_id: project_id, _options: true})).then(
//    (res) => {
//       cb(res);
//     }
//   )
// };

// Front-end join from multiple grids
const fetchPrefilledRows = (queryObject, project_id, programme_form_id, cb) => {
  console.log(queryObject)
  let fetchPromises = [];
  let joinTables = {};

  (queryObject.joinRows || []).forEach((grid) => {
    if (grid.datagridId == queryObject.prefillRows.datagridId) return;
    joinTables[grid.presetId] = grid; 
  })

  joinTables = Object.values(joinTables);

  fetchPromises.push(
    fetch(datagrid_get_grouped_rows_by_preset_path({
      id: queryObject.prefillRows.datagridId, 
      datagrid_preset_id: queryObject.prefillRows.presetId, 
      used_group_cols: queryObject.prefillRows.selectedGrouping, 
      project_id: project_id,
      programme_form_id: programme_form_id,
      _options: true
    }))
    .then(response => response.json())
    .catch(error => console.log(error))
  );

  joinTables.forEach((joinGrid) => {
    fetchPromises.push(
      fetch(datagrid_get_grouped_rows_by_preset_path({
        id: joinGrid.datagridId, 
        datagrid_preset_id: joinGrid.presetId, 
        used_group_cols: joinGrid.selectedGrouping, 
        project_id: project_id,
        programme_form_id: programme_form_id,
        _options: true
      }))
      .then(response => response.json())
      .catch(error => console.log(error))
    );
  });


Promise.all(fetchPromises)
  .then(values => {
    const mainRows = values[0];
    joinTables.forEach((joinGrid, index) => {
      const joinData = values[index + 1];
      joinData.forEach(row => {
        const matchingRowIndex = mainRows.findIndex(mRow => {
          return queryObject.prefillRows.selectedGrouping.every((groupCol, index) => {
            if (_.isObject(mRow[groupCol]) && _.isObject(row[joinGrid.selectedGrouping[index]])) {
              return mRow[groupCol].id === row[joinGrid.selectedGrouping[index]].id;
            }
            return mRow[groupCol] === row[joinGrid.selectedGrouping[index]];
          })
        })
     

        mainRows[matchingRowIndex] = Object.assign({}, mainRows[matchingRowIndex], row);
      })
      // Each join data, find a match in mainRow and merge.
    });
    cb(mainRows);
  })
  .catch(error => console.log(error));
}
